module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"PDAX API","short_name":"PDAX API","start_url":"/","background_color":"#f7f0eb","theme_color":"#2b5797","display":"standalone","icon":"data/images/logo-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"cba7490de28f6a5470b9ff9c24ee3353"},
    }]
